// Development environment configuration
export const environment = {
  production: false,

  // Skip OIDC authentication in development (for testing without Keycloak)
  skipAuth: false,

  // Dev credentials for NavVis (only used when skipAuth is true)
  devNavvisCredentials: {
    username: 'admin',
    password: 'CQBZNN9a',
  },

  // OIDC Configuration
  oidc: {
    authority: 'https://identity.tskoda.vwgroup.com/realms/standard',
    // Use the public client ID (needs to be registered in Keycloak)
    // For testing, you can try the existing client: 'skomap_f5dab09d'
    clientId: 'skomap_f5dab09d',
    // HTTPS on skomap-local.skoda-auto.com (registered in Keycloak)
    // Requires: 127.0.0.1 skomap-local.skoda-auto.com in /etc/hosts
    // Run server with: sudo npm run serve
    redirectUrl: 'https://skomap-local.skoda-auto.com/AuthenticationCallback',
    postLogoutRedirectUri: 'https://skomap-local.skoda-auto.com',
    scope: 'openid profile email',
  },

  // API Configuration
  api: {
    // Middleware API base URL (local Docker instance with HTTPS)
    middlewareUrl: 'https://localhost:5001',
    // NavVis IVION API URL
    navvisUrl: 'https://skomap-dev.iv.navvis.com',
  },

  // Default NavVis site ID for development
  defaultNavvisSiteId: 3523240812043393,
};
